<div class="card mb-5" *ngIf="data" [attr.style]="(data.colStyle || '') + (data.rowStyle || '')">
  <div class="card-header" style="border-bottom: none; padding: 6px 8px;">
    <div style="display:flex; align-items:center; justify-content:space-between; width:100%;">
      <div class="card-title d-flex flex-column">
        <h6 style="margin: 0; font-size: calc(16px * var(--dvm-font-scale, 1));" [style.text-align]="data.titleAlignment || 'center'">{{ data.title }}</h6>
      </div>

      <div class="card-actions" style="display:flex; gap:8px; align-items:center;">
        <button *ngIf="altFunctions?.length" class="btn btn-sm btn-outline-secondary toggle-btn" (click)="toggleFunctionName()">
          {{ currentAltIndex === -1 ? (data.altFunctionToggleLabel || 'Switch') : (data.altFunctionLabel || 'Agg. Change') }}
        </button>
      </div>
    </div>
  </div>
  <div class="card-body" style="padding: 6px; position: relative;">
    <!-- Chart container: direct child div[id] so global responsive CSS + service font scaling apply -->
    <div #chartRef [id]="data.widgetId" class="dvm-chart-tall" style="width: 100%;" [style.height]="data.height || 'var(--dvm-chart-height-lg, 455px)'"></div>

    <!-- Custom horizontal scrollbar -->
    <div class="scrollbar-track horizontal" *ngIf="totalEngineCount > maxVisibleEngines">
      <div class="scrollbar-thumb horizontal"
           [style.width.px]="getScrollbarThumbWidth()"
           [style.left.px]="getScrollbarThumbLeft()"
           (mousedown)="onScrollbarMouseDown($event)">
      </div>
    </div>
  </div>
</div>